module.exports = __webpack_public_path__ + "static/media/american.2b0c27fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/american.png
// module id = 1988
// module chunks = 0